export default __webpack_public_path__ + "static/media/toggle_bg.d84ac723.svg";